import { render } from "./CorsoDetail.vue?vue&type=template&id=129f86fc"
import script from "./CorsoDetail.vue?vue&type=script&lang=js"
export * from "./CorsoDetail.vue?vue&type=script&lang=js"

import "./CorsoDetail.vue?vue&type=style&index=0&id=129f86fc&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__